export const userLogColumns = [
    {
        key: 'firstName',
    },
    {
        key: 'lastName',
    },
    {
        key: 'email',
    },
    {
        key: 'username',
    },
    {
        key: 'nhsNumber',
    },
    {
        key: 'dob',
    },
    {
        key: 'genderValue',
    },
    {
        key: 'occupation',
    },
    {
        key: 'identityWithHeldReasonValue',
    },
    {
        key: 'maritalStatusValue',
    },
    {
        key: 'religionValue',
    },
    {
        key: 'accommodationStatusValue',
    },
    {
        key: 'diagnosticValue',
    },
    {
        key: 'deviceAssigned',
    },
    {
        key: 'active',
    },
    {
        key: 'address',
    },
    {
        key: 'addressLine1',
    },
    {
        key: 'addressLine2',
    },
    {
        key: 'addressLine3',
    },
    {
        key: 'addressLine4',
    },
    {
        key: 'city',
    },
    {
        key: 'state',
    },
    {
        key: 'country',
    },
    {
        key: 'createdAt',
    },
    {
        key: 'modifiedBy',
    },
]

export const parameterLogColumns = [
    {
        key: 'heartRateLower',
    },
    {
        key: 'heartRateUpper',
    },
    {
        key: 'respirationLower',
    },
    {
        key: 'respirationUpper',
    },
    {
        key: 'temperatureLower',
    },
    {
        key: 'temperatureUpper',
    },
    {
        key: 'systolicLower',
    },
    {
        key: 'systolicUpper',
    },
    {
        key: 'oxygenLower',
    },
    {
        key: 'oxygenUpper',
    },
    {
        key: 'glucoseLower',
    },
    {
        key: 'glucoseUpper',
    },
    {
        key: 'stepsLower',
    },
    {
        key: 'stepsUpper',
    },
    {
        key: 'sleepLower',
    },
    {
        key: 'sleepUpper',
    },
    {
        key: 'comment',
    },
    {
        key: 'createdAt',
    },
    {
        key: 'modifiedBy',
    },
]

export const watchConfigColumns = [
    {
        key: 'firstTimeSendingData',
    },
    {
        key: 'intervalSendingData',
    },
    {
        key: 'intervalReadingSp02',
    },
    {
        key: 'intervalReadingSteps',
    },
    {
        key: 'intervalReadingSleep',
    },
    {
        key: 'intervalReadingHeartRate',
    },
    {
        key: 'intervalReadingLocation',
    },
    {
        key: 'intervalReadingTemperature',
    },
    {
        key: 'modifiedBy',
    },
    {
        key: 'createdAt',
    },
]
export const hcpRoleColumns = [
    {
        key: 'roleName',
    },
    {
        key: 'hospitalName',
    },
    {
        key: 'modifiedBy',
    },
    {
        key: 'createdAt',
    },
]

export const watchNotificationColumns = [
    {
        key: 'title',
    },
    {
        key: 'body',
    },
    {
        key: 'image',
    },
]

export const biometricsColumns = [
    {
        key: 'height',
    },
    {
        key: 'weight',
    },
    {
        key: 'bmi',
    },
    {
        key: 'modifiedBy',
    },
    {
        key: 'createdAt',
    },
]

export const dischargeColumns = [
    {
        key: 'diagnosis',
    },
    {
        key: 'clinicalNarrative',
    },
    {
        key: 'investigations',
    },
    {
        key: 'procedures',
    },
    {
        key: 'socialHistory',
    },
    {
        key: 'medicationChanges',
    },
    {
        key: 'allergies',
    },
    {
        key: 'futurePlans',
    },
    {
        key: 'informationGivenToPatient',
    },
    {
        key: 'informationGivenToGP',
    },
    {
        key: 'modifiedBy',
    },
    {
        key: 'createdAt',
    },
]

export const exportColumns = [
    {
        key: 'modifiedBy',
    },
    {
        key: 'createdAt',
    },
]

export const importColumns = [
    {
        key: 'totalRecords',
    },
    {
        key: 'modifiedBy',
    },
    {
        key: 'createdAt',
    },
]

export const onWristColumns = [
    {
        key: 'from',
    },
    {
        key: 'to',
    },
    {
        key: 'duration',
    },
]

export const batterChargeLogColumns = [
    {
        key: 'from',
    },
    {
        key: 'to',
    },
    {
        key: 'duration',
    },
    {
        key: 'percentage',
    },
]
